// frontend/src/lib/utils.js
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format date to DD/MM/YYYY format
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Formatted date string in DD/MM/YYYY format
 */
export function formatDate(dateInput) {
  if (!dateInput || dateInput === 'unknown') return 'Unknown';
  
  const date = new Date(dateInput);
  
  // Check if date is valid
  if (isNaN(date.getTime())) return 'Invalid Date';
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
}

/**
 * Format date and time to DD/MM/YYYY HH:MM format
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} Formatted date and time string
 */
export function formatDateTime(dateInput) {
  if (!dateInput || dateInput === 'unknown') return 'Unknown';
  
  const date = new Date(dateInput);
  
  // Check if date is valid
  if (isNaN(date.getTime())) return 'Invalid Date';
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
